import { useState } from "react";
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import Calendar from '../../components/Calendar/Calendar';
import './Task.css';

function MyCalendar() {
    const [tasks, setTasks] = useState([]);
    const [classes, setClasses] = useState([]);

    const handleTasksChange = (updatedTasks) => {
        setTasks(updatedTasks);
    };

    const handleClassesChange = (updatedClasses) => {
        setClasses(updatedClasses);
    };


    return (
        <div className="mycalendar-container">
            <Sidebar />
            <Header />
            <div className="calendar-main-content">
                <div className="mycalendar-content">
                    <Calendar onTasksChange={handleTasksChange} onClassesChange={handleClassesChange} />
                </div>
            </div>
        </div>
    );
}

export default MyCalendar;
